var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personTit"},[_c('div',{staticClass:"left"},[_vm._v("您好，欢迎您来到中国建筑 (中小企业)产业互联网平台")]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"personCount"},[_vm._v(_vm._s(_vm.personCount))]),_c('span',{staticClass:"logoutBtn",on:{"click":_vm.loginOut}},[_vm._v("退出")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cac55a9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/persontit/index.vue
// module id = null
// module chunks = 